import {convertToClientDate} from './DateHelper';
import {FRONTEND_DATE2} from 'Common/constants/Date';

function withDate(value: string, format?: string): string | null {
  return value ? convertToClientDate(value, format || FRONTEND_DATE2) : null;
}

export default withDate;
